import React from 'react';
import PropTypes from 'prop-types';
//import choiceDataPropTypes from '../../propTypes/choiceData';
import {t} from '../../Translations'
import Label from './Label';
import Button from "../widgets/Button";

const LabelButton = ({index,classLabel, label, classes, onClick, disabled,data,onChange}) => (
    <div key={index} className="row my-4 my-md-2">
    <div className="col-12 col-md-6 step1-label info-bulle">
      <Label>{`${t('Step1_form_rims')}*`}</Label>
    </div>
  
        <div className="col-12 col-md-6">
        <label className={classLabel} style={{color:"grey"}} >{t('Step1_form_info_selectionnez')}</label>
        <Button 
        className={classes} onClick={onClick} disabled={disabled} data={data} onChange={onChange}>
              {t('Step1_form_info_choisir')}
        </Button>
        </div>
    </div> 
  );
  
  LabelButton.propTypes = {
    index: PropTypes.number,
    //label: PropTypes.string.isRequired,
    classes: PropTypes.string,
    //data: choiceDataPropTypes.isRequired,
    disabled: PropTypes.bool,
    classLabel: PropTypes.string,
    onClick: PropTypes.func
  };
  
  LabelButton.defaultProps = {
    index: 0,
    value: undefined,
    classLabel:""
    //loading: false
  };
  
  export default LabelButton;


// WEBPACK FOOTER //
// ./src/components/widgets/LabelButton.js